<template>
  <div>
  <ubi-panel>
    <ubi-form-group :title="$t('posts.defiscTitle')">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_loi_pinel">
            {{ $labels.defisc_loi_pinel }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_loi_duflot">
            {{ $labels.defisc_loi_duflot }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_loi_censi_bouvard">
            {{ $labels.defisc_loi_censi_bouvard }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_loi_girardin_paul">
            {{ $labels.defisc_loi_girardin_paul }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_loi_malraux">
            {{ $labels.defisc_loi_malraux }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_loi_demessine">
            {{ $labels.defisc_loi_demessine }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_regime_scpi">
            {{ $labels.defisc_regime_scpi }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_nue_propriete_demembrement">
            {{ $labels.defisc_nue_propriete_demembrement }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.pret_locatif_social">
            {{ $labels.pret_locatif_social }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.compatible_psla">
            {{ $labels.compatible_psla }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_loi_mh">
            {{ $labels.defisc_loi_mh }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.compatible_ptz_plus">
            {{ $labels.compatible_ptz_plus }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_tva_5_virgule_5_pourcent">
            {{ $labels.defisc_tva_5_virgule_5_pourcent }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_tva_7_pourcent">
            {{ $labels.defisc_tva_7_pourcent }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.accession_maitrisee">
            {{ $labels.accession_maitrisee }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.accession_libre">
            {{ $labels.accession_libre }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.bail_reel_solidaire">
            {{ $labels.bail_reel_solidaire }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.habitat_participatif">
            {{ $labels.habitat_participatif }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_statut_lmp">
            {{ $labels.defisc_statut_lmp }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.defisc_statut_lmnp">
            {{ $labels.defisc_statut_lmnp }}
          </el-checkbox>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="margin-top: 20px">
          <el-form-item label="Organisme foncier solidaire">
            <el-input v-model="post.organisme_foncier_solidaire"/>
          </el-form-item>
        </el-col>
      </el-row>

    </ubi-form-group>
  </ubi-panel>

  <ubi-panel>
    <ubi-form-group :title="$t('posts.certificationsAndLabelsTitle')">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_hqe">
            {{ $labels.label_hqe }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_nf_maison_individuelle">
            {{$labels.label_nf_maison_individuelle}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_he">
            {{$labels.label_he}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_thpe">
            {{$labels.label_thpe}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_hpe_enr">
            {{$labels.label_hpe_enr}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_bbc">
            {{$labels.label_bbc}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_he_effinergie">
            {{$labels.label_he_effinergie}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.re_2020">
            {{$labels.re_2020}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.plan_local_habitat">
            {{ $labels.plan_local_habitat }}
          </el-checkbox>
        </el-col>
      </el-row>
    </ubi-form-group>
  </ubi-panel>
  </div>
</template>
<script>
import UbiPanel from '../../../../components/Panel'
export default {
  name: 'Defisc',
  components: { UbiPanel },
  props: ['post'],
  data () {
    return {}
  }
}
</script>

<style>

</style>
